import FulfilmentsUtil from "../../utils/fulfilments-util";
const util = new FulfilmentsUtil();

export default {
  methods: {
    deleteColumn(headerValue) {
      let id = this.pressedId;

      if (headerValue.includes("step")) {
        this.deleteStepColumn(id);
      } else if (headerValue.includes("responsible")) {
        this.deleteResponsibleColumn(id);
      }
    },

    deleteStepColumn(id) {
      let stepNumber = id - (this.responsibles.length + 3);
      let lengthOfStep = this.steps.length;

      this.steps.splice(stepNumber, 1);
      this.headers.splice(id, 1);

      // Renumber steps
      for (let a = 0; a < this.steps.length; a++) {
        this.steps[a].identity = `step${a + 1}`;
        this.steps[a].text = `step${a + 1}`;
      }

      let counter1 = 1;
      for (let b = 3 + this.responsibles.length; b < this.headers.length - 1; b++) {
        if (this.headers[b].text.includes("Step")) {
          this.headers[b].text = `Step${counter1}`;
        }
        this.headers[b].value = `step${counter1}`;
        counter1++;
      }

      // Update deliverables
      for (let c = 0; c < this.deliverables.length; c++) {
        for (let d = stepNumber; d < this.steps.length; d++) {
          this.deliverables[c][`step${d + 1}`] = this.deliverables[c][`step${d + 2}`];
        }

        util.calculateRowFulfillment(this.deliverables[c], this.steps);

        if (this.deliverables[c].isGrouped) {
          this.deliverables[c].children.forEach((child) => {
            util.calculateRowFulfillment(child, this.steps);
          });
        }

        delete this.deliverables[c][`step${lengthOfStep}`];
      }

      this.updateStoreAfterColumnDelete();
      util.recalculateAllFulfillments(this.deliverables, this.steps);
    },

    deleteResponsibleColumn(id) {
      // Shift responsible columns
      for (let y = 0; y < this.deliverables.length; y++) {
        let x = id;
        for (x; x < this.responsibles.length + 3; x++) {
          if (this.deliverables[y][`responsible${x - 1}`]) {
            this.deliverables[y][`responsible${x - 2}`] = this.deliverables[y][`responsible${x - 1}`];
          } else if (!this.deliverables[y][`responsible${x - 1}`]) {
            this.deliverables[y][`responsible${x - 2}`] = "";
          }
        }
      }

      // Remove last responsible
      for (let z = 0; z < this.deliverables.length; z++) {
        delete this.deliverables[z][`responsible${this.responsibles.length}`];
      }

      this.headers.splice(id, 1);
      this.responsibles.splice(id - 3, 1);

      // Renumber responsibles
      for (let e = 0; e < this.responsibles.length; e++) {
        this.responsibles[e].identity = `responsible${e + 1}`;
        this.responsibles[e].text = `Responsible${e + 1}`;
      }

      let counter2 = 1;
      for (let f = 3; f < this.responsibles.length + 3; f++) {
        if (this.headers[f].text.includes("Responsible")) {
          this.headers[f].text = `Responsible${counter2}`;
        }
        this.headers[f].value = `responsible${counter2}`;
        counter2++;
      }

      this.updateStoreAfterColumnDelete();
    },

    updateStoreAfterColumnDelete() {
      this.$store.dispatch("setHeaders", this.headers);
      this.$store.dispatch("setResponsibles", this.responsibles);
      this.$store.dispatch("setDeliverables", this.deliverables);
      this.$store.dispatch("setNextColumnName", this.$store.getters.getNextColumnName("Status"));
      this.toggleShowConformMessage();
    },
  },
};
